export enum NetConfigMode {
    SMART_CONFIG = 'SMART_CONFIG',
    SOFTAP = 'SOFTAP',
}
